import { Link, Outlet } from "react-router-dom";

export function App() {
  return (
    <div className="app-shell">
      <header className="nav">
        <Link to="/" className="brand">
          SENTRY U2U
        </Link>
        <nav>
          <Link to="/">Dashboard</Link>
          <Link to="/new-job">New job</Link>
        </nav>
      </header>
      <main className="container">
        <Outlet />
      </main>
      <footer className="footer">
        <small>
          This tool holds no funds. Mnemonics are encrypted client-side before
          they ever leave your browser.
        </small>
      </footer>
    </div>
  );
}
